module.exports = __webpack_public_path__ + "img/home-03.14e3a554.png";